import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GroupsService } from '../services/groups.service';
import { UserService } from '../services';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'group-membership-button',
    template: `
        <button mat-raised-button *ngIf="currentUser && isMember" matTooltip="Leave" (click)="leave()">Leave</button>
        <button mat-raised-button *ngIf="currentUser && !isMember" matTooltip="Join" (click)="join()" color="primary">Join</button>
    `
})
export class GroupMembershipButtonComponent implements OnInit, OnChanges {
    currentUser: any;
    @Input() group;
    isMember: boolean;

    constructor(public snackBar: MatSnackBar,
                private groupService: GroupsService,
                private userService: UserService) {}
    
    ngOnInit(): void {
        this.currentUser = this.userService.getCurrentUser();
    }
    
    leave(): void {
        this.groupService.removeUser(this.group.id, this.currentUser.id)
        .pipe(
            tap(() => this.group.membersCount--),
            tap(() => this.group.members.splice(this.group.members.indexOf(this.currentUser.id), 1)),
            tap(() => this.isMember = false),
            tap(() => this.snackBar.open(`You have left ${this.group.name}.`, 'OK', { duration: 3000}))
        ).subscribe();
    } 

    join(): void {
        this.groupService.addUser(this.group.id, this.currentUser.id)
        .pipe(
            tap(() => this.group.membersCount++),
            tap(() => this.group.members.push(this.currentUser.id)),
            tap(() => this.isMember = true),
            tap(() => this.snackBar.open(`You have joined ${this.group.name}.`, 'OK', { duration: 3000}))
        ).subscribe();
    }

    ngOnChanges(): void {
        this.isMember = this.group && this.group.members && this.group.members.includes(this.userService.getCurrentUser().id);
    }
}
